import { theme } from '../theme.js';

const STATUS_META = {
  ok:        { label: 'OK',        tone: 'ok'      },
  missing:   { label: 'Missing',   tone: 'danger'  },
  broken:    { label: 'Broken',    tone: 'danger'  },
  attention: { label: 'Attention', tone: 'warn'    },
  rectified: { label: 'Rectified', tone: 'service' },
} as const;

type CheckStatus = keyof typeof STATUS_META;
type StatusTone = keyof typeof theme.status;

interface Props {
  status: CheckStatus;
  size?: 'sm' | 'md' | 'lg';
}

export function StatusPill({ status, size = 'md' }: Props) {
  const meta = STATUS_META[status];
  const tone = theme.status[meta.tone as StatusTone];
  const fontSize = size === 'sm' ? 11 : size === 'lg' ? 14 : 12;
  const padY = size === 'sm' ? 3 : size === 'lg' ? 6 : 4;
  const padX = size === 'sm' ? 7 : size === 'lg' ? 12 : 9;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      background: tone.bg, color: tone.fg,
      padding: `${padY}px ${padX}px`,
      borderRadius: 999, fontSize, fontWeight: 600,
      whiteSpace: 'nowrap', flexShrink: 0,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: 3, background: tone.dot, flexShrink: 0 }} />
      {meta.label}
    </span>
  );
}

export function StatusDot({ status, size = 8 }: { status?: CheckStatus; size?: number }) {
  if (!status) {
    return <span style={{
      width: size, height: size, borderRadius: size / 2,
      border: `1.5px dashed ${theme.borderHi}`, display: 'inline-block', flexShrink: 0,
    }} />;
  }
  const meta = STATUS_META[status];
  const dot = theme.status[meta.tone as StatusTone].dot;
  return <span style={{
    width: size, height: size, borderRadius: size / 2,
    background: dot, display: 'inline-block', flexShrink: 0,
  }} />;
}
